<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add()">新增</Button>
		</div>
		<div class="query">
			<div class="checkbox">
				
			</div>
			<Input search enter-button placeholder="请输入厂商名称" style="width: 500px;" v-model="query.like" @on-blur="likeQuery" />
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">详情</Button>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				loading: false,
				total: 0,
				query: { //查询参数
					page: 0,
					size: 10,
					like: ''
				},
				modal2: false,
				modal_loading: false,
				deleteId: '',
				columns12: [ {
						title: 'id',
						key: 'id',
						width:400,
						align:'center',
					},
					{
						title: '厂家名称',
						key: 'name',
						width:400,
						align:'center',
					},
					{
						title: '备注',
						key: 'remark',
						width:400,
						align:'center',
					},
					{
						title: '操作',
						slot: 'action',
						width: 100,
						align: 'center'
					}
					
				],
				data6: [
					/* 	{
						id: '1',
						companyName: '',
						address: '',
						phone1: '',
						phone2: '',
						phone3: '',
						mailbox: '',
						operType: '',
						state: '',
						createdTime: '2010-10-10'

					}, */
				]

			}
		},
		methods: {
			xinzeng(){
				 this.$router.push({
					name: 'jm/admin/xinwenzixun/add'
				 })
			},
			onchangeSousuo1(a){
				this.query.appType=a
				this.ajaxPage()
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			update(id) { //修改
				this.$router.push({
					name: 'jm/admin/manu/update',
					query: {
						id: id
					}
				})
			},
			forbidden(id) {
				this.deleteId = id
				this.modal2 = true
			},
			add() {
				this.$router.push({
					name: 'jm/admin/manu/add'
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			likeQuery() {
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/oper/comm/manu/page/oper',
					data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.operCommManu.totalElements
						_this.data6 = data.operCommManu.content

						_this.loading = false
					}
					//假设后台需要的是表单数据这里你就可以更改
				})

			}

		},
		components: {
			page
		},
		created() {
			this.ajaxPage();
		},
		activated(){
			this.ajaxPage();
		}


	}
</script>
<style scoped="scoped">
	.ivu-table-cell {
		padding-left: 0px !important;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/manu/list.vue